// GN: preço com o cupom PRIMEIRACOMPRA para visitantes não logados (o script só é carregado para eles).
// - Ainda não resgatou: "R$ X na 1ª compra" nos cards e o selo laranja da página do produto com o preço grande.
// - Já resgatou (classe gn-cupom-pc no <html>, posta no <head>): "R$ X com cupom" e o selo vira "Você paga".
// O CSS esconde tudo quando o CEP calculado está fora da área (compra vai para o Mercado Livre).
(() => {
  const CODIGO = 'PRIMEIRACOMPRA';
  const PERCENTUAL = 10;
  const html = document.documentElement;
  const real = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  const comCupom = (centavos) => Math.round((centavos * (100 - PERCENTUAL)) / 100) / 100;

  const preencher = (raiz) => {
    const resgatado = html.classList.contains('gn-cupom-pc');
    raiz.querySelectorAll?.('.gn-preco-cupom').forEach((el) => {
      const centavos = Number(el.dataset.centavos);
      if (!centavos) return;
      const estado = resgatado ? 'resgatado' : 'oferta';
      if (el.dataset.pronto === estado) return;
      const valor = real.format(comCupom(centavos));
      el.innerHTML = resgatado
        ? `<strong>${valor}</strong> com cupom<span> ${CODIGO}</span>`
        : `<strong>${valor}</strong> na 1ª compra<span> com cupom</span>`;
      el.dataset.pronto = estado;
    });

    // Selo da página do produto: preço grande, acompanhando a variação escolhida
    document.querySelectorAll('.gn-pc__selo-preco').forEach((alvo) => {
      const bloco = alvo.closest('.product__info-container') || document;
      const base = bloco.querySelector('.price--large .gn-preco-cupom[data-centavos]');
      const centavos = Number(base?.dataset.centavos);
      const texto = centavos ? real.format(comCupom(centavos)) : '';
      // Só escreve se mudou: escrever sempre dispararia o MutationObserver em ciclo
      if (texto && alvo.textContent !== texto) alvo.textContent = texto;
    });
  };

  // Chamado pelo pop-up logo após o resgate
  document.addEventListener('gn:primeira-compra-lead', () => {
    html.classList.add('gn-cupom-pc');
    preencher(document);
  });

  /**
   * Libera o PRIMEIRACOMPRA para quem deixou o contato em outro formulário (pop-up do WhatsApp, página
   * Contato): marca como resgatado e já deixa o cupom aplicado para o checkout. Não libera para quem
   * calculou um CEP fora da área. Só existe para visitantes não logados (este script só carrega para eles).
   * Devolve a promessa da aplicação do cupom (ou null quando não liberou).
   */
  window.gnLiberarCupomPrimeiraCompra = (nome) => {
    try {
      if (localStorage.getItem('gn-frete-status') === 'fora') return null;
      if (!localStorage.getItem('gn-cupom-primeira-compra')) {
        localStorage.setItem(
          'gn-cupom-primeira-compra',
          JSON.stringify({ nome: nome || '', data: new Date().toISOString(), origem: 'contato' })
        );
      }
    } catch (e) {
      return null;
    }
    html.classList.add('gn-cupom-pc');
    preencher(document);
    return fetch((window.Shopify?.routes?.root || '/') + 'discount/' + CODIGO, { credentials: 'same-origin' }).catch(
      () => null
    );
  };

  const iniciar = () => {
    // Quem já tinha deixado o contato no pop-up do WhatsApp antes desta regra também ganha o cupom
    try {
      if (!localStorage.getItem('gn-cupom-primeira-compra') && localStorage.getItem('gn-whatsapp-contato')) {
        const contato = JSON.parse(localStorage.getItem('gn-whatsapp-contato')) || {};
        window.gnLiberarCupomPrimeiraCompra(contato.nome);
      }
    } catch (e) {}
    preencher(document);
    // Troca de variação / carrinho / filtros re-renderizam o preço: preenche os novos
    new MutationObserver((mudancas) => {
      if (mudancas.some((m) => m.addedNodes.length)) preencher(document);
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
